import type { FunctionComponent, ReactNode } from "react";
import { useRef } from "react";
import { Transition } from "react-transition-group";
import type { TimeoutProps } from "react-transition-group/Transition";

import { Container } from "./styles";

export type Props = Partial<TimeoutProps<HTMLDivElement>> & {
  children?: ReactNode;
  inProperty: boolean;
  timeout?: number;
};

export const Fade: FunctionComponent<Props> = ({
  children,
  inProperty,
  timeout = 300,
  ...props
}) => {
  const reference = useRef<HTMLDivElement>(null);
  return (
    <Transition
      appear
      in={inProperty}
      mountOnEnter
      timeout={timeout}
      unmountOnExit
      {...props}
      nodeRef={reference}
    >
      {state => (
        <Container $state={state} $timeout={timeout} ref={reference}>
          {children}
        </Container>
      )}
    </Transition>
  );
};

Fade.displayName = "Fade";
